module.exports = __webpack_public_path__ + "images/muo_logo-0dbc1d1c9951f1bdb905706aea0fd45b.png";


//////////////////
// WEBPACK FOOTER
// ./app/frontend/images/muo_logo.png
// module id = 209
// module chunks = 0